import { Tab } from "@mui/material";
import { MprcChipTabs } from "components/MprcChipTabs";
import { useTranslation } from "react-i18next";
import { TeamPanelAnalisyTabProps } from "views/dashboard/TeamPanel";

export const TeamAnalisySelector = ({ analisySelected, onAnalisyChanged }: TeamPanelAnalisyTabProps) => {
    const { t } = useTranslation("dashboard");

    return (
        <MprcChipTabs size="small" variant="scrollable" value={analisySelected} onChange={(e, value) => onAnalisyChanged(value)} >
            <Tab label={t("TeamPanel.Analysis.TIndex")} value="tindex" />
            <Tab label={t("TeamPanel.Analysis.Training")} value="training" />
            <Tab label={t("TeamPanel.Analysis.Challenge")} value="challenge" />
            <Tab label={t("TeamPanel.Analysis.Knowledge")} value="knowledge" />
            <Tab label={t("TeamPanel.Analysis.Award")} value="award" />
        </MprcChipTabs>
    );
};
